import React from 'react';
import { Datagrid, List, ShowButton, TextField } from 'react-admin';
import { DeviceListActions } from '../actions';

export default ({ permissions, ...props }) => (
    <List actions={<DeviceListActions permissions={permissions} />} bulkActionButtons={false} title='Devices' {...props} >
        <Datagrid>
            <TextField label="EUI" source="eui" />
            <TextField source="name" />
            <TextField source="group" />
            <TextField label="State" source="lora.state" />
            <TextField label="Timestamp" source="lora.ts" />
            <ShowButton />
        </Datagrid>
    </List>
);
